import ManagePreferences from './ManagePreferences'
export default ManagePreferences
